/** Data em que o paciente efetivamente pagou (não confundir com vencimento ou repasse). */
export function resolveReceivablePaymentDate(rec: {
  paid_date?: string | null;
  payment_date?: string | null;
  metadata?: Record<string, unknown> | null;
  payments?: Array<{ date?: string | null }> | null;
} | null | undefined): string | null {
  if (!rec) return null;

  const meta = rec.metadata && typeof rec.metadata === 'object' ? rec.metadata : {};
  const direct =
    rec.paid_date
    || rec.payment_date
    || (meta.patient_paid_at ? String(meta.patient_paid_at) : null);

  if (direct) return String(direct).slice(0, 10);

  const payments = Array.isArray(rec.payments) ? rec.payments : [];
  if (payments.length === 0) return null;

  const latest = [...payments]
    .map((p) => String(p?.date || '').slice(0, 10))
    .filter(Boolean)
    .sort()
    .pop();

  return latest || null;
}
